 <template>
  <div
    id="brandExportModal"
    class="modal fade"
    tabindex="-1"
    role="dialog"
    aria-labelledby="modelSingle"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-lg" role="document">
      <!--begin::Form-->
      <form class="kt-form" @submit="formSubmit">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{this.$route.meta.breadcrumb}}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="kt-portlet__body">
              <div class="kt-section kt-section--first">
                <div class="row">
                  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6">
                    <div class="form-group">
                      <label class="label">ประเภทงบประมาณ :</label>
                      <select2
                      :class="'form-control m-select2'"
                      :style="'width: 100%;'"
                      :id="'exBudgetType'"
                      :name="'exBudgetType'"
                      :select2-options="exBudgetTypeOptions"
                      v-model="exBudgetType"
                      ref="exBudgetTypeSelect2"
                    ></select2>
                    </div>
                  </div>
                  <!-- Begin:ปี(งบประมาณ) input -->
                <div class="col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6">
                  <div class="form-group">
                    <label>ปี(งบประมาณ) :</label>
                    <select2
                      :class="'form-control m-select2'"
                      :style="'width: 100%;'"
                      :id="'exYear'"
                      :name="'exYear'"
                      :select2-options="exYearOptions"
                      v-model="exYear"
                      ref="exYearSelect2"
                    ></select2>
                  </div>
                </div>
                <!-- End:ปี(งบประมาณ) input -->
                <!-- Begin:Status select2 -->
                <div class="col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6">
                  <div class="form-group">
                    <label>สถานะ:</label>
                    <select2
                      :css-style="'width: 100%;'"
                      :css-class="'form-control'"
                      :id="'exStatus'"
                      :name="'exStatus'"
                      :select2-options="exStatusOptions"
                      v-model="exStatus"
                      ref="exStatusSelect2"
                    ></select2>
                  </div>
                </div>
                <!-- End:Status select2 -->
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">
              <i class="la la-close"></i> ปิดหน้าต่าง
            </button>
            <button type="submit" class="btn btn-primary">
              <i class="la la-save"></i> Export
            </button>
          </div>
        </div>
      </form>
      <!--end::Form-->
    </div>
  </div>
</template>

<script>
import axios from "axios";
import select2 from "../../../Shared/Select2";

export default {
  components: {
    select2
  },
  data: function() {
    var self = this;
    return {
      DlbRefno: [],
      exBudgetType:"",
      exYear:null,
      exStatus:null,
      exBudgetTypeOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Variables/Options",
          data: function(params) {
            var query = {
              search: "BUDGET_TYPE",
              page: params.page || 1
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      exYearOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/BudgetBrand/Select2BudgetYear",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      exStatusOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: [
          { id: "false", text: "ใช้งาน", data: null },
          { id: "true", text: "ปิดใช้งาน", data: null }
        ]
      }
    };
  },
  methods: {
    formReset() {
        this.exStatus = false;
        $("#exStatus")
        .val(this.exStatus + "")
        .trigger("change");

        this.exYear = null;
        $("#exYear")
        .val(this.exYear + "")
        .trigger("change");

        this.exBudgetType = "";
        $("#exBudgetType")
        .val(this.exBudgetType + "")
        .trigger("change");
    },
    formSubmit: function(e) {
        var self = this;
        let router = this.$router;

        e.preventDefault();

        if (
            !$("#brandExportModal form")
            .validate()
            .form()
        ) {
            return false;
        }

        KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังโหลดข้อมูล กรุณารอสักครู่..."
        });

        axios({
            method: "post",
            url: "/Api/BudgetBrand/Export",
            responseType: "arraybuffer",
            data: {
                BudgetType: (self.exBudgetType != "") ? [self.exBudgetType] : [],
                Year: self.exYear,
                ActiveStatus: self.exStatus
                }
            }).then(function(response) {
                let filename = "";
                let contentType = response.headers["content-type"];
                let disposition = response.headers["content-disposition"];

                //===Get Filename===
                if (disposition && disposition.indexOf("attachment") !== -1) {
                    var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                    var matches = filenameRegex.exec(disposition);
                    if (matches != null && matches[1]) {
                    filename = matches[1].replace(/['"]/g, "");
                    }
                }

                //Save file
                let blob = new Blob([response.data], { type: contentType });
                let link = document.createElement("a");
                link.href = window.URL.createObjectURL(blob);
                link.download = filename;
                link.click();
                
            }).catch(function(error) {
                Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            }).then(function() {
                self.formReset();
                KTApp.unblockPage();
            });
    }
  },
  async mounted() {
    let self = this;
    let router = this.$router;
    
    //default Active Data
    self.exStatus = false;
    $("#exStatus")
      .val(self.exStatus + "")
      .trigger("change");

    // set validation rules
    $("#brandExportModal form").validate({
      rules: { DlbRefno: "required" },
      messages: { DlbRefno: "กรุณาเลือกรหัสอ้างอิง" }
    });

    $("#brandExportModal")
      .on("hidden.bs.modal", function() {
        // Set go back
        router.go(-1);
        self.$parent.reloadDataTable(false);
      })
      .modal("show");
  }
};
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// App/Components/Master/Brand/BrandExportModal.vue